<template>
    <el-dialog title="产品图片" :visible.sync="dialogVisible" width="800px" :before-close="closeDialog"
        custom-class="product-img-dialog" :append-to-body="true">
        <div class="dialog-content">
            <div class="img-list">
                <div v-for="(img, index) in imgList" :key="index" class="img-item"
                    :class="{ active: currentIndex === index }" @click="selectImg(index)">
                    <img :src="getImgUrl(img)" alt="产品图片" />
                </div>
            </div>
            <div class="img-preview">
                <div class="img-container">
                    <img v-if="currentImg" :src="getImgUrl(currentImg)"
                        :style="{ transform: `rotate(${rotateAngle}deg)` }" alt="产品图片" />
                    <div v-else class="no-img">暂无图片</div>
                </div>
                <div class="img-controls">
                    <el-button type="primary" size="small" @click="rotateLeft">向左旋转</el-button>
                    <el-button type="primary" size="small" @click="rotateRight">向右旋转</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'ProductImg',
    props: {
        productId: {
            type: [String, Number],
            required: true
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: this.visible,
            imgList: [],
            currentIndex: 0,
            rotateAngle: 0
        }
    },
    computed: {
        currentImg() {
            return this.imgList[this.currentIndex] || ''
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
            if (!val) {
                this.$emit('close')
            } else {
                this.getProductImages()
            }
        }
    },
    methods: {
        async getProductImages() {
            this.loading = true
            try {
                let res = await this.$newsApi.GetProductImg({ product_id: this.productId });
                res = res.data;
                this.imgList = [];
                if (res && res.Resultcode === 0 && res.data) {
                    // 解析返回的图片列表字符串
                    let imgList = res.data.replace(/"/g, '').split(',')
                    if (imgList[0] == '/images/detail_no_pic.gif') {
                        this.imgList.push('/images/detail_no_pic.gif')
                    } else {
                        this.imgList = imgList.filter(img => img != '/images/detail_no_pic.gif')
                    }
                    this.currentIndex = 0
                }
            } catch (error) {
                console.error('获取产品图片失败', error)
            } finally {
                this.loading = false
            }
        },
        getImgUrl(path) {
            if (!path) return '';
            if (path.indexOf("detail_no_pic") > 0) return path;
            if (/^https?:\/\//.test(path)) return path;
            return this.$openFileUrl + path;
        },
        selectImg(index) {
            this.currentIndex = index
            this.rotateAngle = 0 // 重置旋转角度
        },
        rotateLeft() {
            this.rotateAngle = (this.rotateAngle - 90 + 360) % 360
        },
        rotateRight() {
            this.rotateAngle = (this.rotateAngle + 90) % 360
        },
        closeDialog() {
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped>
.product-img-dialog {
    display: flex;
    flex-direction: column;
}

.dialog-content {
    display: flex;
    height: 500px;
}

.img-list {
    width: 140px;
    overflow-y: auto;
    border-right: 1px solid #eee;
    padding: 10px;
}

.img-item {
    width: 100px;
    height: 100px;
    margin-bottom: 10px;
    border: 2px solid transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.img-item.active {
    border-color: #409EFF;
}

.img-item img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.img-preview {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.img-container {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s;
    overflow: hidden;
    /* 防止旋转后溢出遮挡按钮 */
    position: relative;
    /* 建立层级上下文 */
}

.img-container img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    transform-origin: center center;
    /* 以中心为旋转原点，避免溢出 */
}

.no-img {
    color: #999;
    font-size: 16px;
}

.img-controls {
    margin-top: 20px;
    display: flex;
    gap: 10px;
    position: relative;
    z-index: 2;
    /* 提高层级，确保按钮可点击 */
}
</style>